import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import AppHeader from '../components/AppHeader'
import BrokerProfileForm from '../components/BrokerProfileForm'
import { useAuth } from '../contexts/AuthContext'

export default function BrokerProfilePage() {
  const { isAuthenticated, user, getAccessToken } = useAuth()

  if (!isAuthenticated || !getAccessToken()) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Please sign in to view and edit your profile.</p>
          <Link to="/login" className="btn-primary inline-block">
            Sign In
          </Link>
        </div>
      </div>
    )
  }

  if (user?.userType !== 'broker') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 mb-4">Broker profile only.</p>
          <Link to="/broker" className="btn-primary inline-block">
            Back to Broker Portal
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader
        rightContent={
          <>
            <span className="text-gray-600">Broker Portal</span>
            <Link to="/broker" className="text-sm text-primary-600 hover:text-primary-700">
              Dashboard
            </Link>
          </>
        }
      />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Link
          to="/broker"
          className="inline-flex items-center text-gray-600 hover:text-primary-600 mb-6"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Dashboard
        </Link>

        <BrokerProfileForm />
      </div>
    </div>
  )
}
